import tw from "twin.macro";

export const Container = tw.div`relative`;
export const Content2Xl= tw.div`max-w-screen-2xl mt-8 mx-auto`;
